import { useContextMenuMESF, useShiftNavigator } from "@dexteel/mesf-core";
import { Grid2 as Grid } from "@mui/material";
import { GridApi, GridReadyEvent, themeMaterial } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { useEffect, useMemo, useRef, useState } from "react";
import { useGridDefinitions } from "../../../../controls/ag-grid/components/GridDefinitions";
import { useCasterDashboardContext } from "../../CasterDashboardContext";
import { useProductionTableData } from "../useProductionTableData";
import { CommentsModal } from "./components/CommentsModal";
import { useOptionsFunctions } from "./hooks/useOptionsFunctions";

export const CasterProductionTable = () => {
	const gridRef = useRef<AgGridReact>(null);
	const { shiftInfo } = useShiftNavigator();
	const {
		state: { casterProductions, isLoadingProductionGrid },
	} = useCasterDashboardContext();
	const [gridAPI, setGridAPI] = useState<GridApi | null>(null);
	const [comment, setComment] = useState<string | null>(null);
	const [showCommentModal, setShowCommentModal] = useState(false);

	const { columnTypes } = useGridDefinitions({
		OnEdit: () => {},
	});

	const { columnData, defaultColDef } = useProductionTableData({
		casterProductions,
		setComment,
		setShowCommentModal,
	});
	const { getMenuOptions, goToDataEntry } = useOptionsFunctions();
	const { showContextMenu, registerConfig } = useContextMenuMESF();

	const onGridReady = (params: GridReadyEvent) => {
		setGridAPI(params.api);
	};
	const handleContainerContextMenu = (
		event: React.MouseEvent<HTMLDivElement, MouseEvent>,
	) => {
		event.preventDefault();
	};

	useMemo(() => {
		if (isLoadingProductionGrid && gridAPI) {
			gridAPI.showLoadingOverlay();
		} else if (gridAPI) {
			gridAPI.hideOverlay();
		}
	}, [isLoadingProductionGrid, gridAPI]);

	useEffect(() => {
		registerConfig({
			id: "casterProductionTable",
			getOptions: getMenuOptions,
		});
	}, [shiftInfo?.CurrentShiftId]);
	return (
		<>
			<Grid container>
				<Grid
					size={{ xs: 12 }}
					style={{
						border: "1px solid #e0e0e0",
						height: "50vh",
						minHeight: "30vh",
						margin: "20px 0 10px",
					}}
				>
					<AgGridReact
						ref={gridRef}
						rowSelection="single"
						defaultColDef={defaultColDef}
						onGridReady={onGridReady}
						rowData={casterProductions}
						columnDefs={columnData}
						columnTypes={columnTypes}
						suppressContextMenu={true}
						onRowDoubleClicked={(event: any) => {
							goToDataEntry(event.data.ProcessId);
						}}
						onCellContextMenu={(event) => {
							if (event.event)
								showContextMenu(
									event.event as any,
									event.data,
									"casterProductionTable",
								);
						}}
					/>
				</Grid>
			</Grid>
			<CommentsModal
				comments={comment}
				onHide={() => setShowCommentModal(false)}
				open={showCommentModal}
			/>
		</>
	);
};
